<template>
  <div class="element-input element-textbox element-certification" :class="{ disabled }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <input type="tel" v-model="model" :disabled="disabled" :placeholder="placeholder" />

      <a @click="clickCertification">인증</a>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
import { EventBus } from '@/plugins/event-bus';
export default {
  props: [ "value", "label", "error", "disabled", "placeholder" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created() {
    EventBus.$on('clickCertification', this.clickCertification);
  },
  beforeDestroy() {
    EventBus.$off('clickCertification', this.clickCertification);
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },
    clickCertification(){
      if (this.model.length < 1) {
        alert("번호를 입력해주세요.");
        return;
      }
      alert( "인증번호를 보냈습니다." );
      this.$emit( "certification", { check: true, value: this.value });
    }
  }

}
</script>
